import type * as React from 'react';

import { cn } from '@/lib/utils';

interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Valeur technique (clé, événement, capacité) : mono 11px. */
  mono?: boolean;
}

/**
 * `tag` : pastille neutre (fond `muted`, filet `border`, rayon sm, 20px) pour
 * une catégorie, un fournisseur, une capacité, un rôle. Ce n'est pas un statut :
 * un statut passe par `Badge`.
 */
function Tag({ mono = false, className, ...props }: TagProps): React.JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex h-5 shrink-0 items-center whitespace-nowrap rounded-sm border border-border bg-muted px-1.5 text-xs text-muted-foreground',
        mono && 'font-mono text-[11px]',
        className,
      )}
      {...props}
    />
  );
}

export { Tag };
